module.exports = __webpack_public_path__ + "static/media/blog_4.21975b2f.jpg";